<template>
  <v-snackbar v-model="showNotification" :timeout="notification.timeout" :color="notification.color" location="top">
    <div class="notification-message">
      {{ notification.message }}
    </div>
    <template v-slot:actions>
      <v-btn variant="text" @click="showNotification = false"> X </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useNotificationStore } from "@/stores/notification";

const notificationStore = useNotificationStore();

const notification = computed(() => {
  return notificationStore.globalNotification;
});

const showNotification = computed({
  get() {
    return notification.value && !!notification.value.message;
  },
  set(value) {
    notificationStore.clearNotification();
  }
});
</script>

<style scoped>
.notification-message {
  white-space: pre-line;
}
</style>
